import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { translations } from "../../lib/i18n";
import { TEST_IDS } from "../../constants/testIds";

const Process = () => {
  const { lang } = useLang();
  const t = translations[lang].process;

  return (
    <section
      id="process"
      data-testid={TEST_IDS.process.root}
      className="rp-section bg-[color:var(--rp-bg)]"
    >
      <div className="rp-container">
        <div className="mb-14">
          <div className="rp-eyebrow mb-4">07 · Process</div>
          <h2 className="rp-heading rp-headline max-w-[24ch]">{t.title}</h2>
        </div>

        <div className="relative">
          <div className="process-line hidden md:block" aria-hidden />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {t.steps.map((step, i) => (
              <motion.div
                key={i}
                data-testid={TEST_IDS.process.step(i)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative"
              >
                <div className="relative flex items-center justify-center md:justify-start mb-4">
                  <span className="w-3 h-3 bg-[color:var(--rp-accent)] relative z-10" />
                </div>
                <div className="font-display font-bold text-white text-lg tracking-widest">
                  0{i + 1}
                </div>
                <div className="mt-3 text-[11px] tracking-[0.22em] uppercase text-[color:var(--rp-muted)] leading-relaxed max-w-[24ch]">
                  {step}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
